// Audit tab: timeline of actions on the request. Reverse-chronological so
// the latest event is at the top.

import i18next from 'i18next';
import { Icon, JournalTimeline, type JournalTimelineEntry } from '../../../../ui/index.js';
import { useTranslation } from 'react-i18next';
import { roleLabel } from '../../../../shared/index.js';
import { formatDateTime } from '../../format.js';
import type { RequestView } from '../../types.js';
import { STATUS_LABEL_KEYS_TECHNICAL } from '../RequestStatusPill.js';

export interface AuditTabProps {
  request: RequestView;
}

export function AuditTab({ request: r }: AuditTabProps) {
  const { t } = useTranslation('requests');
  if (!r.audit.length) {
    return (
      <div
        style={{
          padding: '48px 20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 10,
          color: 'var(--fg-3)',
        }}
      >
        <Icon name="scroll-text" size={24} style={{ color: 'var(--fg-4)' }} />
        <div style={{ fontSize: 13 }}>{t('audit.empty')}</div>
      </div>
    );
  }

  const entries: JournalTimelineEntry[] = [...r.audit].reverse().map((e, i) => ({
    key: String(i),
    primary: (
      <>
        {e.text}
        {e.from && e.to && (
          <span style={{ marginLeft: 6, fontSize: 11, color: 'var(--fg-3)' }}>
            {t(STATUS_LABEL_KEYS_TECHNICAL[e.from])} → {t(STATUS_LABEL_KEYS_TECHNICAL[e.to])}
          </span>
        )}
      </>
    ),
    metadata: (
      <>
        <span>{e.by ? e.by.name : i18next.t('audit:actorDeleted', { defaultValue: '' })}</span>
        {e.by && <span>{roleLabel(e.by.role)}</span>}
        <span>· {formatDateTime(e.at)}</span>
      </>
    ),
  }));

  return (
    <div style={{ padding: '12px 24px 24px' }}>
      <JournalTimeline entries={entries} />
    </div>
  );
}
